// extracted by mini-css-extract-plugin
export default {"container":"PostFeed__container___mNfE5","postFeedCon":"PostFeed__postFeedCon___zJJNi","postFeedItem":"PostFeed__postFeedItem___ngNgY"};